var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Item',{attrs:{"video":_vm.video,"text":_vm.post.text,"post":_vm.post},on:{"openComments":_vm.openComments}})
}
var staticRenderFns = []

export { render, staticRenderFns }